import api from "@/api/axios";

const ROLES_URL = "/roles";

// --- Role CRUD ---
export const getRoles = () => api.get(ROLES_URL);
export const getRole = (id) => api.get(`${ROLES_URL}/${id}`);
export const createRole = (role) => api.post(ROLES_URL, role);
export const updateRole = (id, role) => api.put(`${ROLES_URL}/${id}`, role);
export const deleteRole = (id) => api.delete(`${ROLES_URL}/${id}`);
